// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
import { environment } from "../services/environment.js";
if (environment.isDevelopment()) {
  console.log("Vite ⚡️ Rails");
  console.log(
    "Visit the guide for more information: ",
    "https://vite-ruby.netlify.app/guide/rails",
  );
}

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
import "~/stylesheets/application.css";

import Rails from "@rails/ujs";
Rails.start();

// Import Rails libraries
import "@hotwired/turbo-rails";

import "../helpers/local_time.js";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import "alpine-turbo-drive-adapter";
import Alpine from "alpinejs";
window.Alpine = Alpine;

// Initialize ChatKit panel Alpine.js component
import { initChatkitPanel } from "../helpers/chatkit_panel.js";
initChatkitPanel();

// Initialize secure navigation Alpine.js component
import { initNavigation } from "../helpers/navigation.js";
initNavigation();

Alpine.start();

// Import local modules
import Pagy from "../layouts/pagy-module.js";
window.Pagy = Pagy;

import I18nHelper from "../helpers/i18n.js";

import "../core_extensions/index.js";
import "../layouts/flash.js";
import "../layouts/collapse.js";

import "../channels/index.js";
import "../controllers/index.js";

// Custom Turbo Stream actions
import "../turbo_stream_actions/index.js";
